// removed by extract-text-webpack-plugin
module.exports = {"ArticleHeader":"ArticlePage__ArticleHeader___3t8Mc"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicContainers/ArticlePage/ArticlePage.less
// module id = 1118
// module chunks = 0 1